// theme-sources/js/elements/ziggy-pack.js
import { logger } from "../core/logger";
import { THEME_EVENTS, publish, subscribe } from "../../shared/events";
import { fetchConfig } from "../core/utils";
import { syncCartFakeItem } from "../features/cart-fake-item";

class ZiggyPack extends HTMLElement {
  constructor() {
    super();
    this.state = {
      initialPack: 0,
      pack: 0,
      discount: 0,
      tempCart: { variants: [], total: 0, discounted: 0 },
    };

    this.isWidgetOpen = true;
  }

  connectedCallback() {
    this.packButtons = this.querySelectorAll("[data-pack-select]");
    this.bindPackSelection();

    const initialPack = parseInt(this.dataset.initialPack || "0", 10);
    const discount = parseFloat(this.dataset.discount || "0");

    this.state.initialPack = initialPack;
    this.state.pack = initialPack;
    this.state.discount = discount;

    logger.info("ZiggyPack", "initialized", {
      initialPack,
      discount,
    });

    if (window.__ZIGGY_DEBUG__ === true) {
      this.__debugState = () => this.state;
    }

    this.widget = this.querySelector("[data-pack-widget]");
    this.renderWidget(this.state);
    this.addEventListener("ziggy-pack:state", (event) =>
      this.renderWidget(event.detail),
    );

    this.buyButtons = this.querySelectorAll("[data-pack-buy]");
    this.bindBuyButtons();
    this.buyButtons.forEach((button) => {
      const price = Number(button.dataset.variantPrice);
      const priceEl = button.querySelector("[data-pack-price]");
      if (!priceEl) return;
      priceEl.textContent = this.formatDiscounted(price);
    });

    this.addEventListener("click", (event) => {
      const removeBtn = event.target.closest("[data-pack-remove]");
      if (!removeBtn) return;
      const index = parseInt(removeBtn.dataset.index, 10);
      logger.info("ZiggyPack", "remove clicked", { index });
      this.updateTempCart(index, 1);
    });

    this.ctaButton = this.querySelector("[data-pack-cta]");

    if (this.ctaButton) {
      this.ctaButton.addEventListener("click", () => {
        this.handleAddPackToCart();
      });
    }

    /*subscribe(THEME_EVENTS.cartUpdate, () => {
      this.handleCartSuccess();
    });*/

    this.toggleBtn = this.querySelector("[data-toggle-widget]");
    this.slotsGroup = this.querySelector("[data-pack-slots]");

    if (this.toggleBtn && this.slotsGroup) {
      this.toggleBtn.addEventListener("click", () => {
        this.isWidgetOpen = !this.isWidgetOpen;

        this.slotsGroup.style.display = this.isWidgetOpen ? "flex" : "none";

        this.toggleBtn.classList.toggle("is-open", this.isWidgetOpen);
      });

      // état initial
      this.slotsGroup.style.display = this.isWidgetOpen ? "flex" : "none";
      this.toggleBtn.classList.toggle("is-open", this.isWidgetOpen);
    }
  }

  updateAllButtonPrices() {
    this.buyButtons.forEach((button) => {
      const original = Number(button.dataset.variantPrice);
      const priceEl = button.querySelector("[data-pack-price]");
      if (!priceEl) return;

      const discounted = original - (original * this.state.discount) / 100;

      priceEl.textContent = (discounted / 100).toLocaleString("fr-FR", {
        style: "currency",
        currency: "EUR",
      });
    });
  }

  updateRemainingPack() {
    this.state.pack =
      this.state.initialPack - this.state.tempCart.variants.length;
  }

  bindPackSelection() {
    this.packButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.handlePackSelection(button);
      });
    });
  }

  handlePackSelection(button) {
    const newInitial = parseInt(button.dataset.pack, 10);
    const newDiscount = parseFloat(button.dataset.discount);

    logger.info("ZiggyPack", "pack selection clicked", {
      newInitial,
      newDiscount,
    });

    // Actif UI
    this.packButtons.forEach((b) => b.classList.remove("active"));
    button.classList.add("active");

    // ✅ Mettre à jour la taille du pack
    this.state.initialPack = newInitial;

    // ✅ Mettre à jour le discount
    this.state.discount = newDiscount;

    this.updateAllButtonPrices();

    // Ajuster les variants si trop nombreux
    if (this.state.tempCart.variants.length > newInitial) {
      this.state.tempCart.variants = this.state.tempCart.variants.slice(
        0,
        newInitial,
      );
    }

    // ✅ Source de vérité unique
    this.updateRemainingPack();

    this.recalculate();
    this.dispatchState();
  }

  bindBuyButtons() {
    this.buyButtons.forEach((button) => {
      button.addEventListener("click", () => {
        this.handleBuy(button);
      });
    });
  }

  handleBuy(button) {
    const variantId = button.dataset.variantId;
    const variantPrice = button.dataset.variantPrice;
    const variantImage = button.dataset.variantImage;

    const success = this.addToTempCart({
      variantId,
      variantPrice,
      variantImage,
      packDiscount: this.state.discount,
    });

    if (!success) {
      logger.warn("ZiggyPack", "pack full, cannot add");
    }
  }

  renderWidget(state) {
    if (!this.widget) return;

    const initialEl = this.widget.querySelector("[data-pack-initial]");
    const countEl = this.widget.querySelector("[data-pack-count]");
    const productLabelEl = this.widget.querySelector(
      "[data-pack-product-label]",
    );
    const productTitleEl = this.widget.querySelector(
      "[data-pack-product-title]",
    );
    const productLabelInlineEl = this.widget.querySelector(
      "[data-pack-product-label-inline]",
    );

    const totalEl = this.widget.querySelector("[data-pack-total]");
    const discountedEl = this.widget.querySelector("[data-pack-discounted]");
    const remainingEl = this.widget.querySelector("[data-pack-remaining]");
    const cta = this.widget.querySelector("[data-pack-cta]");
    const ready = this.widget.querySelector("[data-cta-ready]");
    const incomplete = this.widget.querySelector("[data-cta-incomplete]");
    const slots = this.widget.querySelector("[data-pack-slots]");

    const discountBadge = this.widget.querySelector(
      "[data-pack-discount-badge]",
    );
    const discountValue = this.widget.querySelector(
      "[data-pack-discount-value]",
    );

    const hasVariants = state.tempCart.variants.length > 0;
    const selectedCount = state.tempCart.variants.length;
    const remainingCount = state.pack;
    const initialCount = state.initialPack;

    const productOne = this.widget.dataset.i18nProductOne || "produit";
    const productOther = this.widget.dataset.i18nProductOther || "produits";
    const productSelectedOne =
      this.widget.dataset.i18nProductSelectedOne || "produit sélectionné";
    const productSelectedOther =
      this.widget.dataset.i18nProductSelectedOther || "produits sélectionnés";

    logger.info("ZiggyPack", "renderWidget", {
      hasWidget: !!this.widget,
      hasSlots: !!slots,
      pack: state.pack,
    });

    if (initialEl) {
      initialEl.textContent = state.initialPack;
    }

    if (countEl) {
      countEl.textContent = selectedCount;
    }

    if (productTitleEl) {
      productTitleEl.textContent = initialCount > 1 ? productOther : productOne;
    }

    if (productLabelEl) {
      productLabelEl.textContent =
        selectedCount > 1 ? productSelectedOther : productSelectedOne;
    }

    if (productLabelInlineEl) {
      productLabelInlineEl.textContent =
        remainingCount > 1 ? productOther : productOne;
    }

    if (discountBadge && discountValue) {
      discountValue.textContent = state.discount;

      // visible seulement si aucun produit sélectionné
      if (!hasVariants && state.discount > 0) {
        discountBadge.classList.remove("hidden");
      } else {
        discountBadge.classList.add("hidden");
      }
    }

    this.widget.hidden = false;

    if (totalEl && discountedEl) {
      if (hasVariants) {
        totalEl.textContent = this.format(state.tempCart.total);
        discountedEl.textContent = this.format(state.tempCart.discounted);

        totalEl.classList.toggle("hidden", state.discount === 0);
        totalEl.parentElement.classList.remove("hidden");
      } else {
        totalEl.parentElement.classList.add("hidden");
      }
    }

    if (remainingEl) remainingEl.textContent = state.pack;

    if (cta) {
      const complete = state.pack === 0;

      cta.disabled = !complete;
      ready.hidden = !complete;
      incomplete.hidden = complete;
    }

    if (slots) {
      slots.innerHTML = "";

      state.tempCart.variants.forEach((item, index) => {
        const div = document.createElement("div");
        div.innerHTML = `
        <div class="temp-cart-item relative">
          <div class="w-[60px] h-[60px] border border-dashed rounded-lg overflow-hidden border-primary mx-1.5">
            <img src="${item.image}" class="w-full" />
          </div>
          <button data-pack-remove data-index="${index}" class="absolute -top-2 right-0 w-7 h-7 cursor-pointer flex items-center justify-center p-1.5 rounded-full bg-white hover:bg-border focus:bg-border">
            <svg width="20" height="20" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon--remove fill-primary w-5">
              <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
              <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
            </svg>
          </button>
        </div>
      `;
        slots.appendChild(div.firstElementChild);
      });

      for (let i = 0; i < state.pack; i++) {
        const empty = document.createElement("div");
        empty.className =
          "w-[60px] h-[60px] border border-dashed rounded-lg overflow-hidden border-primary mx-1.5";
        slots.appendChild(empty);
      }
    }
  }

  addToTempCart({ variantId, variantPrice, variantImage, packDiscount }) {
    if (this.state.pack <= 0) {
      logger.warn("ZiggyPack", "add blocked: pack is full");
      return false;
    }

    if (typeof packDiscount === "number") {
      this.state.discount = packDiscount;
    }

    this.state.tempCart.variants.push({
      id: Number(variantId),
      price: Number(variantPrice),
      image: variantImage,
    });

    this.updateRemainingPack();

    this.recalculate();

    logger.info("ZiggyPack", "variant added", {
      variantId,
      remaining: this.state.pack,
      variants: this.state.tempCart.variants.length,
    });

    this.dispatchState();
    return true;
  }

  updateTempCart(index, deleteCount = 1, discount) {
    if (typeof discount === "number") {
      this.state.discount = discount;
    }

    this.state.tempCart.variants.splice(index, deleteCount);
    this.updateRemainingPack();

    this.recalculate();

    logger.info("ZiggyPack", "variant removed", {
      index,
      remaining: this.state.pack,
      variants: this.state.tempCart.variants.length,
    });

    this.dispatchState();
  }

  async handleAddPackToCart() {
    if (this.state.pack !== 0) return;

    this.ctaButton.disabled = true;
    this.ctaButton.setAttribute("aria-disabled", "true");
    this.querySelector(".loading__spinner")?.classList.remove("hidden");

    try {
      const items = this.state.tempCart.variants.map((item) => ({
        id: item.id,
        quantity: 1,
        properties: { __pack: true },
      }));

      logger.info("ZiggyPack", "sending pack to cart", { items });

      await this.removeExistingPack();

      const cartDrawer = document.querySelector("cart-drawer");

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";

      const body = { items };

      if (cartDrawer) {
        body.sections = cartDrawer
          .getSectionsToRender()
          .map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      config.body = JSON.stringify(body);

      const response = await fetch(`${theme.routes.cart_add_url}`, config).then(
        (res) => res.json(),
      );

      if (response.status) {
        publish(THEME_EVENTS.cartError, {
          source: "ziggy-pack",
          errors: response.errors || response.description,
        });
        return;
      }

      const finalState = await syncCartFakeItem({
        baseState: response,
        sections: body.sections || [],
        sectionsUrl: window.location.pathname,
      });

      publish(THEME_EVENTS.cartUpdate, {
        source: "ziggy-pack",
        cartData: finalState,
      });

      this.handleCartSuccess(finalState);
    } catch (error) {
      logger.error("ZiggyPack", "Pack add error:", error);
    } finally {
      this.ctaButton.disabled = false;
      this.ctaButton.removeAttribute("aria-disabled");
      this.querySelector(".loading__spinner")?.classList.add("hidden");
    }
  }

  async removeExistingPack() {
    const cart = await fetch(`${theme.routes.cart_url}.js`).then((res) =>
      res.json(),
    );
    const packItems = cart.items.filter(
      (item) => item.properties?.__pack === true,
    );
    if (!packItems.length) return;
    const updates = {};
    packItems.forEach((item) => {
      updates[item.key] = 0;
    });
    await fetch(`${theme.routes.cart_update_url}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates }),
    });
  }

  handleCartSuccess(cartData) {
    const cartDrawer = document.querySelector("cart-drawer");
    const ziggyDrawer = document.querySelector("ziggy-drawer[name='cart']");

    if (!cartData) {
      logger.warn("ZiggyPack", "handleCartSuccess called without cartData");
      ziggyDrawer?.open();
      return;
    }

    const drawerSectionId = cartDrawer?.dataset.sectionId;
    const hasRenderableSections =
      !!cartData?.sections &&
      !!drawerSectionId &&
      !!cartData.sections[drawerSectionId] &&
      !!cartData.sections["cart-icon-bubble"];

    logger.info("ZiggyPack", "handleCartSuccess", {
      hasSections: !!cartData?.sections,
      sectionKeys: Object.keys(cartData?.sections || {}),
      hasRenderableSections,
    });

    if (cartDrawer && hasRenderableSections) {
      cartDrawer.renderContents(cartData);
    }

    ziggyDrawer?.open();
  }

  resetTempCart() {
    this.state.tempCart.variants = [];
    this.updateRemainingPack();
    this.recalculate();
    this.dispatchState();
  }

  recalculate() {
    let total = 0;
    let discounted = 0;

    this.state.tempCart.variants.forEach((item) => {
      const price = Number(item.price);
      total += price;

      const discountedLine = Math.round(
        price * (1 - this.state.discount / 100),
      );

      discounted += discountedLine;
    });

    this.state.tempCart.total = total;
    this.state.tempCart.discounted = discounted;
  }

  format(amount) {
    return (amount / 100).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
    });
  }

  formatDiscounted(priceInCents) {
    const discounted =
      priceInCents - (priceInCents * this.state.discount) / 100;
    return (discounted / 100).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
    });
  }

  dispatchState() {
    this.dispatchEvent(
      new CustomEvent("ziggy-pack:state", {
        detail: { ...this.state },
        bubbles: true,
      }),
    );
  }
}

if (!customElements.get("ziggy-pack")) {
  customElements.define("ziggy-pack", ZiggyPack);
}
